import { createRouter, createWebHistory } from "vue-router";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import mis_rutas from "./routes/MisRutas";
const appLoading = document.getElementById("loading-bg");

const routes = [
  ...mis_rutas,
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    redirect: "error-404",
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),

  scrollBehavior: (to, from, savePosition) => {
    if (savePosition) {
      return savePosition;
    } else {
      if (to.hash) {
        return {
          selector: to.hash,
        };
      }
      return { x: 0, y: 0 };
    }
  },

  routes,
});

router.clearQuerys = () => {
  const newRouter = router.history.current.name;
  if (newRouter) {
    router.replace({ name: newRouter });
  }
};

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("token") ? true : false;

  // if (to.name === 'biografia.preview') {
  //   if (appLoading) {
  //     appLoading.style.display = "flex";
  //   }
  // }

  if (!canNavigate(to) && !isLoggedIn) {
    next({ name: "login" });
  } else if (!canNavigate(to) && isLoggedIn) {
    next({ name: "misc-not-authorized" });
  } else if (to.meta?.redirectIfLoggedIn === true && isLoggedIn) {
    next({ name: "home" });
  } else {
    next();
  }
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach((to) => {
  // Remove initial loading

  if (appLoading) {
    appLoading.style.display = "none";
  }

  // If navigation includes a hash, try to scroll to the element reliably
  const scrollToHash = (hash) => {
    if (!hash) return;
    const id = String(hash).replace(/^#/, "");

    const findElement = () => {
      let el = document.getElementById(id);
      if (el) return el;
      try {
        const esc = window.CSS && CSS.escape ? `#${CSS.escape(id)}` : `#${id}`;
        el = document.querySelector(esc);
        if (el) return el;
      } catch (e) {
        // ignore
      }
      el = document.querySelector(`[data-scroll-id="${id}"]`);
      return el;
    };

    const header = document.querySelector(".fixed-top");
    const headerOffset = header ? header.offsetHeight : 0;

    let attempts = 0;
    const maxAttempts = 40; // retry ~40 frames (~600ms)

    const tryScroll = () => {
      attempts++;
      const el = findElement();
      if (el) {
        // compute top position considering header offset
        const rect = el.getBoundingClientRect();
        const top = rect.top + window.pageYOffset - headerOffset - 8; // small gap
        window.scrollTo({ top, left: 0, behavior: "smooth" });
        return;
      }
      if (attempts < maxAttempts) {
        requestAnimationFrame(tryScroll);
      }
    };

    requestAnimationFrame(tryScroll);
  };

  if (to.hash) {
    // let Vue Router attempt its own behavior first, then ensure element is reached
    // use a small timeout to allow component mount if necessary
    setTimeout(() => scrollToHash(to.hash), 50);
    return;
  }

  // Ensure we start at the top when navigating to a new route (except when using hash anchors)
  // Vue Router already returns saved positions for back/forward navigation via scrollBehavior.
  // Use rAF to wait for DOM updates before forcing scroll to top.
  if (!to.hash) {
    requestAnimationFrame(() => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch (e) {
        // ignore
      }
    });
  }
});

export default router;
